import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';

export function MagentoInstructions({ techOptions = [], selectedTechOption = null, onSelectTech, onContactDeveloper }) {
  const [accSegment1, accSegment2] = useAccountNumber(true);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>Log in to your Magento account, and open your admin panel.</ListItem>

        <ListItem number={2}>
          Click on <strong>System &gt; Configuration.</strong>
        </ListItem>

        <ListItem number={3}>
          In the panel on the left, under General, click on <strong>Design.</strong>
        </ListItem>

        <ListItem number={4}>
          Click to expand the <strong>HTML Head</strong> section.
        </ListItem>

        <ListItem number={5}>
          Copy and paste the Crazy Egg tracking script below into the <strong>Miscellaneous Scripts</strong> text box.
        </ListItem>
      </ol>

      <CodeSnippet
        code={`<script type="text/javascript" src="//script.crazyegg.com/pages/scripts/${accSegment1}/${accSegment2}.js" async="async"></script>`}
        showMailButton
        onMailButtonClick={onContactDeveloper}
      />

      <ol className="flex flex-col gap-4 mt-4">
        <ListItem number={6}>
          Click on the <strong>Save Config</strong> button.
        </ListItem>
      </ol>

      <div className="my-5 rounded bg-white-lilac-500 px-6 py-5 text-black-pearl-500">
        <strong className="text-body-1 text-black-pearl-500">Note:</strong> If you are using a cache plugin on your
        site, you will need to clear it after you have installed your Crazy Egg code.
      </div>

      <div className="flex flex-col gap-1 mt-5">
        <SupportLink
          href={SupportLinks.install.magento1}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Magento 1 Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check installation</strong> once you have connected Crazy Egg with Magento 1.
      </p>
    </Card>
  );
}
